class GridViewToggle extends HTMLElement {
  constructor() {
    super();
    this.gridContainer = document.querySelector(".product-grid");
    this.init();
  }

  init() {
    // Get saved preference or default to 4 columns
    this.currentView = localStorage.getItem("gridView") || "4";
    this.applyGridView();
    this.bindEvents();

    // Listen for window resize to reapply grid view
    window.addEventListener("resize", () => {
      this.applyGridView();
    });
  }

  bindEvents() {
    this.querySelectorAll(".grid-view-btn").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const view = btn.dataset.gridView;
        this.setGridView(view);
      });
    });
  }

  setGridView(view) {
    // Remove all grid classes
    this.removeAllGridClasses();

    // Update active state
    this.querySelectorAll(".grid-view-btn").forEach((btn) => {
      btn.classList.toggle("active", btn.dataset.gridView === view);
    });

    // Apply new view
    this.currentView = view;
    this.applyGridView();

    // Save preference
    localStorage.setItem("gridView", view);
  }

  removeAllGridClasses() {
    this.gridContainer.classList.remove(
      "grid--1-col-mobile",
      "grid--2-col-mobile",
      "grid--1-col-desktop",
      "grid--2-col-desktop",
      "grid--3-col-desktop",
      "grid--4-col-desktop",
      "grid--5-col-desktop"
    );
  }

  applyGridView() {
    const isMobile = window.innerWidth < 750;

    // Remove existing classes first
    this.removeAllGridClasses();

    if (isMobile) {
      // Mobile views - only 1 and 2 column options
      if (this.currentView === "1") {
        this.gridContainer.classList.add("grid--1-col-mobile");
      } else {
        // Default to 2 columns on mobile for all other views
        this.gridContainer.classList.add("grid--2-col-mobile");
      }
    } else {
      // Desktop views
      this.gridContainer.classList.add(`grid--${this.currentView}-col-desktop`);
    }

    // Set active button based on current view
    this.updateActiveButton();
  }

  updateActiveButton() {
    const isMobile = window.innerWidth < 750;

    this.querySelectorAll(".grid-view-btn").forEach((btn) => {
      const btnView = btn.dataset.gridView;

      if (isMobile) {
        // On mobile, show the appropriate active state
        if (this.currentView === "1" && btnView === "1") {
          btn.classList.add("active");
        } else if (this.currentView !== "1" && btnView === "2") {
          btn.classList.add("active");
        } else {
          btn.classList.remove("active");
        }
      } else {
        // On desktop, show exact match
        btn.classList.toggle("active", btnView === this.currentView);
      }
    });
  }
}

customElements.define("grid-view-toggle", GridViewToggle);

// Apply saved grid view on page load
document.addEventListener("DOMContentLoaded", () => {
  const savedView = localStorage.getItem("gridView");
  if (savedView && document.querySelector(".product-grid")) {
    const gridContainer = document.querySelector(".product-grid");
    const isMobile = window.innerWidth < 750;

    // Remove default theme classes that might conflict
    gridContainer.classList.remove(
      "grid--1-col-tablet-down",
      "grid--2-col-tablet-down",
      "grid--1-col-desktop",
      "grid--2-col-desktop",
      "grid--3-col-desktop",
      "grid--4-col-desktop",
      "grid--5-col-desktop",
      "grid--1-col-mobile",
      "grid--2-col-mobile"
    );

    if (isMobile) {
      if (savedView === "1") {
        gridContainer.classList.add("grid--1-col-mobile");
      } else {
        gridContainer.classList.add("grid--2-col-mobile");
      }
    } else {
      gridContainer.classList.add(`grid--${savedView}-col-desktop`);
    }
  }
});

// Handle resize events
window.addEventListener("resize", () => {
  const toggleElement = document.querySelector("grid-view-toggle");
  if (toggleElement && toggleElement.applyGridView) {
    toggleElement.applyGridView();
  }
});
